import script from "./ERecommendations.vue?vue&type=script&lang=ts&setup=true"
export * from "./ERecommendations.vue?vue&type=script&lang=ts&setup=true"

import "./ERecommendations.vue?vue&type=style&index=0&id=21976fd5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21976fd5"]])

export default __exports__